<template>
  <button @click="onClick">Link Account</button>
</template>

<script>
// @ts-check
import { API, PLAID_PUBLIC_KEY, PLAID_ENV } from "../config"
import store from "../store"
import http from "../http"

export default {
  data: () => ({
    handler: { open: () => {} },
  }),

  async mounted() {
    this.handler = Plaid.create({
      key: PLAID_PUBLIC_KEY,
      countryCodes: ["US"],
      env: PLAID_ENV,
      product: ["transactions"],
      // webhook: "https://requestb.in",
      language: "en",
      // onLoad () {},
      onSuccess: this.onSuccess,
      // onExit (err, metadata) {
      //   if (err != null) {
      //     // The user encountered a Plaid API error prior to exiting.
      //   }
      // },
      // onEvent (eventName, metadata) {
      //   console.log(eventName, metadata)
      // },
    })
  },
  methods: {
    onClick() {
      this.handler.open()
    },
    async onSuccess(publicToken, meta) {
      this.$emit("success", publicToken, meta)
    },
  },
}
</script>
